import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import './VenueClosedConfirmationModal.scss';

const { block, element } = bem('venue-closed-confirmation-modal');

const messages = defineMessages({
  title: {
    id: 'venueClosedConfirmationModal.title',
    defaultMessage: 'Close store for today?',
  },
  description: {
    id: 'venueClosedConfirmationModal.description',
    defaultMessage:
      'Closing your store will cancel all existing orders for today, and customers will not be able to place new orders for the rest of the day.',
  },
  cancel: {
    id: 'venueClosedConfirmationModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'venueClosedConfirmationModal.confirm',
    defaultMessage: 'Confirm',
  },
});

export const VENUE_CLOSED_CONFIRMATION_MODAL_NAME = 'VenueClosedConfirmationModal';

const VenueClosedConfirmationModal = ({ handleCancel, handleConfirm }) => {
  return (
    <Confirm
      title={<Message message={messages.title} />}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.confirm} />}
      hasCloseButton
      hideButtonBorder
      size="large"
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      onRequestClose={handleCancel}>
      {({ title, buttons }) => {
        return (
          <div className={block()}>
            {title}
            <div className={element('description-container')}>
              <Message message={messages.description} />
            </div>
            {buttons}
          </div>
        );
      }}
    </Confirm>
  );
};

VenueClosedConfirmationModal.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
};

export default VenueClosedConfirmationModal;
